import React from 'react';
import * as R from 'ramda';
// helpers/constants
import * as G from '../../../helpers';
import * as GC from '../../../constants';
// features
import LocationForm from '../../location/components/location-form';
// feature fleet-profile
import { TableCell } from '../components/table-cells';
//////////////////////////////////////////////////

const settings = {
  [GC.FIELD_LOCATION_TYPE]: {
    width: 150,
    name: 'titles:type',
    customComponent: (row) =>
      <TableCell text={R.path(['data', GC.FIELD_LOCATION_TYPE, GC.FIELD_DISPLAYED_VALUE], row)} />,
    filter: {
      type: 'string',
      getFieldUiValue: R.path([GC.FIELD_LOCATION_TYPE, GC.FIELD_DISPLAYED_VALUE]),
    },
  },
  [GC.FIELD_TEMPLATE_ID]: {
    width: 150,
    name: 'titles:template-id',
  },
  [GC.FIELD_LOCATION_NAME]: {
    width: 150,
    name: 'titles:name',
  },
  [GC.FIELD_ADDRESS_1]: {
    width: 150,
    name: 'titles:address1',
  },
  [GC.FIELD_ADDRESS_2]: {
    width: 150,
    name: 'titles:address2',
  },
  [GC.FIELD_CITY]: {
    width: 150,
    name: 'titles:city',
  },
  [GC.FIELD_STATE]: {
    width: 150,
    uiType: 'state',
    name: 'titles:state',
  },
  [GC.FIELD_ZIP]: {
    width: 150,
    name: 'titles:zip',
  },
  [GC.FIELD_COUNTRY]: {
    width: 150,
    name: 'titles:country',
  },
  [GC.FIELD_LATITUDE]: {
    width: 150,
    name: 'titles:latitude',
    filter: { type: 'number' },
  },
  [GC.FIELD_LONGITUDE]: {
    width: 150,
    name: 'titles:longitude',
    filter: { type: 'number' },
  },
  [GC.FIELD_RESIDENTIAL]: {
    width: 160,
    type: 'boolean',
    name: 'titles:residential',
    filter: { type: 'boolean' },
  },
  [GC.FIELD_COMMENTS]: {
    width: 400,
    name: 'titles:comments',
  },
};

const defaultReportFields = R.keys(settings);

const report = {
  [GC.FIELD_TYPE]: GC.TRUCK_PROFILE_UI_REPORTS,
  [GC.FIELD_GUID]: `${GC.TRUCK_PROFILE_UI_REPORTS}Locations`,
  fields: G.mapIndexed((name, sequence) => ({ name, sequence }), defaultReportFields),
};

const columnSettings = R.map(R.pick(['name', 'type', 'width', 'filter', 'sortable', 'customComponent']), settings);

export const truckLocationSettings = {
  report,
  columnSettings,
  defaultReportFields,
  groupName: 'locations',
  withResizableColumns: true,
  withUiFiltersAndEditView: true,
  modalAdditionalOptions: { p: '0px' },
  itemTitleArr: ['titles:location', 'Location'],
  additionalTableSettings: { searchableTitles: true },
  formGroupTitleArr: ['titles:locations', 'Locations'],
  endpoints: {
    list: 'truckLocations',
    createOrUpdate: 'truckLocations',
    remove: 'getCurrentTruckLocationEndpoint',
  },
  // helpers
  CustomForm: (props) => {
    const { submitAction, initialValues, primaryObjectGuid } = props;

    return (
      <LocationForm
        {...props}
        entity={initialValues}
        guid={R.propOr(null, GC.FIELD_GUID, initialValues)}
        submitAction={(values) => submitAction(R.assoc(GC.FIELD_TRUCK_GUID, primaryObjectGuid, values))}
      />
    );
  },
};


export const trailerLocationSettings = {
  ...truckLocationSettings,
  report: {
    ...report,
    [GC.FIELD_TYPE]: GC.TRAILER_PROFILE_UI_REPORTS,
    [GC.FIELD_GUID]: `${GC.TRAILER_PROFILE_UI_REPORTS}Locations`,
  },
  endpoints: {
    list: 'trailerLocations',
    createOrUpdate: 'trailerLocations',
    remove: 'getCurrentTrailerLocationEndpoint',
  },
  // components
  CustomForm: (props) => {
    const { submitAction, initialValues, isReadOnlyMode, primaryObjectGuid } = props;

    return (
      <LocationForm
        {...props}
        entity={initialValues}
        isReadOnlyMode={isReadOnlyMode}
        guid={R.propOr(null, GC.FIELD_GUID, initialValues)}
        submitAction={(values) => submitAction(R.assoc(GC.FIELD_TRAILER_GUID, primaryObjectGuid, values))}
      />
    );
  },
};
